<template>
  <div class="x-flex x-min-h-0 x-flex-auto x-flex-col x-bg-neutral-0">
    <div
      class="x-flex x-items-center x-border-b x-border-neutral-90 x-p-24 x-pl-40 x-pr-32 x-text-lead-75"
    >
      <span class="x-title3 x-mr-auto x-text-[22px]">
        {{ $t('toggleAside.showAside') }}
      </span>
      <BaseIdModalClose
        class="x-button-lead x-button-circle x-button-ghost x-text-lead-75"
        modal-id="right-aside"
      >
        <CrossIcon class="x-icon-lg" />
      </BaseIdModalClose>
    </div>
    <div class="x-scroll x-flex-auto x-p-40 x-pr-24 x-pt-0">
      <CustomFacets v-if="x.totalResults > 0" />
    </div>
    <div class="x-flex x-gap-16 x-border-t x-border-neutral-90 x-p-40 x-pb-16 x-pt-24">
      <ClearFilters
        v-slot="{ selectedFilters }"
        class="x-button-lead x-button-outlined x-flex-auto x-rounded-full !x-border-lead-50 x-p-24 x-py-12 x-text-lead-50"
        :always-visible="false"
      >
        {{ $t('selectedFilters.clear', selectedFilters.length, { count: selectedFilters.length }) }}
      </ClearFilters>
      <BaseIdModalClose
        class="x-button-lead x-flex-auto x-rounded-full x-border-none !x-bg-lead-50 x-p-24 x-py-12"
        modal-id="right-aside"
      >
        {{
          $t('facetsPanel.viewResults', x.totalResults, {
            count: x.totalResults,
          } as TranslateOptions)
        }}
      </BaseIdModalClose>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TranslateOptions } from 'vue-i18n'
import { BaseIdModalClose, CrossIcon, use$x } from '@empathyco/x-components'
import { ClearFilters } from '@empathyco/x-components/facets'
import CustomFacets from './facets/custom-facets.vue'

const x = use$x()
</script>
